import tw from 'twin.macro';

import { PencilIcon, TrashIcon } from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

import { GetTemplatesQuery } from '@/libs/graphql';

type Template = NonNullable<GetTemplatesQuery['getTemplates']>[number];

type Props = {
  templates: Template[];
  isViewOnly: boolean;
  onDelete: (template: Template) => void;
};

const TemplatesTable = ({ templates, isViewOnly, onDelete }: Props) => {
  const navigate = useNavigate();

  if (templates.length === 0) {
    return (
      <div tw="flex flex-col items-center justify-center py-12 text-gray-400">
        <p tw="text-sm">ยังไม่มีชุดคำถาม</p>
      </div>
    );
  }

  return (
    <div tw="overflow-x-auto">
      <table tw="w-full text-sm text-left">
        <thead tw="bg-gray-50 text-gray-600 text-xs uppercase">
          <tr>
            <th tw="px-4 py-3">ชื่อชุดคำถาม</th>
            <th tw="px-4 py-3 w-32 text-center">จำนวนคำถาม</th>
            <th tw="px-4 py-3 w-32 text-center">เวลารวม (นาที)</th>
            {!isViewOnly && <th tw="px-4 py-3 w-24 text-right">จัดการ</th>}
          </tr>
        </thead>
        <tbody tw="divide-y divide-gray-100">
          {templates.map((template) => (
            <tr key={template.id} tw="hover:bg-gray-50 transition-colors duration-100">
              <td tw="px-4 py-3 font-medium text-gray-900">{template.name}</td>
              <td tw="px-4 py-3 text-center text-gray-500">{template.totalQuestions ?? 0}</td>
              <td tw="px-4 py-3 text-center text-gray-500">
                {template.duration ? Math.round(template.duration / 60) : 0}
              </td>
              {!isViewOnly && (
                <td tw="px-4 py-3">
                  <div tw="flex justify-end gap-2">
                    <button
                      tw="p-1.5 rounded-lg text-gray-400 hover:(text-gray-600 bg-gray-100) transition-colors duration-100"
                      onClick={() =>
                        navigate(`/backoffice/configuration/templates/${template.id}/edit`)
                      }
                      title="แก้ไข"
                    >
                      <PencilIcon tw="w-4 h-4" />
                    </button>
                    <button
                      tw="p-1.5 rounded-lg text-gray-400 hover:(text-red-500 bg-red-50) transition-colors duration-100"
                      onClick={() => onDelete(template)}
                      title="ลบ"
                    >
                      <TrashIcon tw="w-4 h-4" />
                    </button>
                  </div>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TemplatesTable;
